<template>
<!-- 动态图片 -->
    <div class="pd20">
        <div class="main">
            <!-- list -->
            <div class="list-box">
                <el-table :data="list" show-overflow-tooltip border style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="100" label="序号"></el-table-column>
                <el-table-column prop="id" label="ID" width="100"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" icon="el-icon-edit" 
                            @click="$router.push({
                                path:'/main/text_img_form',
                                query:{
                                    type:'edit',
                                    name:'dynamicImg',
                                    eid:$route.query.id,
                                    id:scope.row.id
                                }
                            })" circle></el-button>
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeHandle(scope.$index, scope.row)" circle></el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
            <!-- 添加按钮 -->
            <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus" 
                @click="$router.push({
                    path:'/main/text_img_form',
                    query:{
                        type:'add',
                        name:'dynamicImg',
                        eid:$route.query.id
                    }
            })" circle></el-button>
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { dynamicList,delDynamic } from "@/api/measurement";
export default {
    data(){
        return{
            list: [],
            pages: {},
        }
    },
    methods:{
        removeHandle(index,row){
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(row.id){
                    delDynamic({
                        id:row.id
                    }).then((data)=>{
                        this.$notify({
                            title: '成功',
                            message: '添加成功',
                            type: 'success'
                        });
                    });
                }
                this.list.splice(index, 1);
            }).catch();
        },
        // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            dynamicList({
                eid:this.$route.query.id,
                page:this.pages?this.pages.page:null,  //页码，默认1
                size:this.pages?this.pages.size:null   //每页数量，默认25
            }).then((data)=>{
                this.pages = data.pager;
                for(let i=0;i<data.list.length;i++){
                    if(data.list[i].status==0){
                        this.list.push(data.list[i]);
                    }
                }
                this.$hideLoading();
            }).catch(()=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>

.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
</style>
